export const WRITING_ASSISTANT_DICTATION_PAGE = 'writingAssistantDictation'
export const WRITING_ASSISTANT_FOCUS_PAGE = 'writingAssistantFocus'

export const writingAssistantLaunchOptionsForPage = page => {
  if (page === WRITING_ASSISTANT_DICTATION_PAGE) {
    return { startTextFieldDictation: true }
  }
  if (page === WRITING_ASSISTANT_FOCUS_PAGE) {
    return { focusTextFieldAtEnd: true }
  }
  return null
}

export const focusWritingAssistantTextFieldAtEnd = ({
  requested,
  alreadyFocused,
  editor
}) => {
  if (!requested || alreadyFocused || !editor) return false
  editor.setCaretPosition(editor.getText().length)
  return true
}

export const focusOrOpenWritingAssistantAtEnd = ({
  keyboard,
  requestPage
}) => {
  if (keyboard?.focusWritingAssistantTextFieldAtEnd?.() === true) {
    return 'focused'
  }
  requestPage(WRITING_ASSISTANT_FOCUS_PAGE)
  return 'opened'
}

export const startWritingAssistantTextFieldDictation = ({
  requested,
  alreadyStarted,
  editor,
  startSpeechInput
}) => {
  if (!requested || alreadyStarted || !editor) return false
  editor.focus()
  startSpeechInput()
  return true
}
